export default __webpack_public_path__ + "static/media/20M.018da12b.jpeg";